import { useState } from 'react';
import { toast } from 'react-toastify';
import { storageService, updateUserDocument } from '../../../database/firebase';

export const useImageUpload = (userId, collection = 'clients') => {
  const [profilePicture, setProfilePicture] = useState(null);
  const [bannerPhoto, setBannerPhoto] = useState(null);
  const [organizationLogo, setOrganizationLogo] = useState(null);

  const uploadProfilePicture = async file => {
    try {
      const path = `profilePictures/${userId || 'default'}`;
      const downloadURL = await storageService.uploadFile(file, path);
      setProfilePicture(downloadURL);
      await updateUserDocument(userId, { profilePicture: downloadURL }, collection);
      toast.success('Profile picture updated successfully!');
    } catch (error) {
      toast.error('Failed to upload profile picture. Please try again.');
      throw error;
    }
  };

  const uploadBannerPhoto = async file => {
    try {
      const path = `bannerPhotos/${userId || 'default'}`;
      const downloadURL = await storageService.uploadFile(file, path);
      setBannerPhoto(downloadURL);
      await updateUserDocument(userId, { bannerPhoto: downloadURL }, collection);
      toast.success('Banner photo updated successfully!');
    } catch (error) {
      toast.error('Failed to upload banner photo. Please try again.');
      throw error;
    }
  };

  const uploadOrganizationLogo = async file => {
    try {
      const path = `organizationLogos/${userId || 'default'}`;
      const downloadURL = await storageService.uploadFile(file, path);
      setOrganizationLogo(downloadURL);
      await updateUserDocument(userId, { organizationLogo: downloadURL }, collection);
      toast.success('Organization logo updated successfully!');
    } catch (error) {
      toast.error('Failed to upload organization logo. Please try again.');
      throw error;
    }
  };

  return {
    profilePicture,
    bannerPhoto,
    organizationLogo,
    setProfilePicture,
    setBannerPhoto,
    setOrganizationLogo,
    uploadProfilePicture,
    uploadBannerPhoto,
    uploadOrganizationLogo,
  };
};
